/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">SW-1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">SW-2</vs-button>
          <vs-button :color="sel==='sw3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw3'">SW-3</vs-button>
          <vs-button :color="sel==='sw4'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw4'">SW-4</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">SW-1 &amp; SW-2 — allow VLANs 56,77 on e0/1–e0/2</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t1-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task1Items" :key="'t1-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">SW-3 &amp; SW-4 — allow VLANs 56,77 on e0/2</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw3','sw4']" :key="'t2-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task2Items" :key="'t2-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">SW-1 &amp; SW-2 e0/1 — native VLAN 99</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t3-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task3Items" :key="'t3-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SW-3 &amp; SW-4 — LACP Port-Channel 34 on e0/0–e0/1</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw3','sw4']" :key="'t4-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task4Items" :key="'t4-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2','sw3','sw4']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(swk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-2" />
          <vue-command v-show="sel==='sw3'" key="sw3" id="sw3_terminal" :commands="sw3Commands" :prompt="sw3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-3" />
          <vue-command v-show="sel==='sw4'" key="sw4" id="sw4_terminal" :commands="sw4Commands" :prompt="sw4Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW-4" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (swk, vm) => ({
  help:            () => createStdout(HELP),
  enable:          () => vm.iosEnable(swk),
  configure:       (x) => vm.iosConfigure(swk, x),
  conf:            (x) => vm.iosConfigure(swk, x),
  interface:       (x) => vm.iosInterface(swk, x),
  int:             (x) => vm.iosInterface(swk, x),
  switchport:      (x) => vm.iosSwitchport(swk, x),
  'channel-group': (x) => vm.iosChannelGroup(swk, x),
  exit:            () => vm.iosExit(swk),
  end:             () => vm.iosEnd(swk),
  copy:            (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Allowed_native_VLAN_LACP_Sim_2.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentIf: null },
      sw2: { mode: 'exec', currentIf: null },
      sw3: { mode: 'exec', currentIf: null },
      sw4: { mode: 'exec', currentIf: null },

      // 5 keys per switch × 4 = 20 total
      sw1Completion: { rangeEntered: false, rangeAllowed: false, e01If: false, e01Native: false, saved: false },
      sw2Completion: { rangeEntered: false, rangeAllowed: false, e01If: false, e01Native: false, saved: false },
      sw3Completion: { e02If: false, e02Allowed: false, rangeEntered: false, channelGroup: false, saved: false },
      sw4Completion: { e02If: false, e02Allowed: false, rangeEntered: false, channelGroup: false, saved: false },

      sw1Commands: null, sw2Commands: null, sw3Commands: null, sw4Commands: null,

      task1Items: [
        { key: 'rangeEntered', label: 'interface range e0/1 - 2' },
        { key: 'rangeAllowed', label: 'switchport trunk allowed vlan 56,77' },
      ],
      task2Items: [
        { key: 'e02If',      label: 'interface e0/2' },
        { key: 'e02Allowed', label: 'switchport trunk allowed vlan 56,77' },
      ],
      task3Items: [
        { key: 'e01If',     label: 'interface e0/1' },
        { key: 'e01Native', label: 'switchport trunk native vlan 99' },
      ],
      task4Items: [
        { key: 'rangeEntered', label: 'interface range e0/0 - 1' },
        { key: 'channelGroup', label: 'channel-group 34 mode active' },
      ],
    };
  },

  computed: {
    sw1Prompt() { const m=this.sw1.mode; return m==='config-if-range'?'SW-1(config-if-range)#':m==='config-if'?'SW-1(config-if)#':m==='config'?'SW-1(config)#':'SW-1#'; },
    sw2Prompt() { const m=this.sw2.mode; return m==='config-if-range'?'SW-2(config-if-range)#':m==='config-if'?'SW-2(config-if)#':m==='config'?'SW-2(config)#':'SW-2#'; },
    sw3Prompt() { const m=this.sw3.mode; return m==='config-if-range'?'SW-3(config-if-range)#':m==='config-if'?'SW-3(config-if)#':m==='config'?'SW-3(config)#':'SW-3#'; },
    sw4Prompt() { const m=this.sw4.mode; return m==='config-if-range'?'SW-4(config-if-range)#':m==='config-if'?'SW-4(config-if)#':m==='config'?'SW-4(config)#':'SW-4#'; },

    task1Progress() {
      const c1=this.sw1Completion, c2=this.sw2Completion;
      return [c1.rangeEntered,c1.rangeAllowed,c2.rangeEntered,c2.rangeAllowed].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress===4; },

    task2Progress() {
      const c3=this.sw3Completion, c4=this.sw4Completion;
      return [c3.e02If,c3.e02Allowed,c4.e02If,c4.e02Allowed].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress===4; },

    task3Progress() {
      const c1=this.sw1Completion, c2=this.sw2Completion;
      return [c1.e01If,c1.e01Native,c2.e01If,c2.e01Native].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress===4; },

    task4Progress() {
      const c3=this.sw3Completion, c4=this.sw4Completion;
      return [c3.rangeEntered,c3.channelGroup,c4.rangeEntered,c4.channelGroup].filter(Boolean).length;
    },
    task4Done() { return this.task4Progress===4; },

    saveProgress() {
      return [this.sw1Completion.saved,this.sw2Completion.saved,this.sw3Completion.saved,this.sw4Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress===4; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
    this.sw3Commands = mkCommands('sw3', this);
    this.sw4Commands = mkCommands('sw4', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    devLabel(k) { return { sw1:'SW-1', sw2:'SW-2', sw3:'SW-3', sw4:'SW-4' }[k] || k; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '').replace(/^ethernet/, '')
        .replace(/^fa(?=\d)/, '').replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion,this.sw2Completion,this.sw3Completion,this.sw4Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 20) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) { this[swk].mode = 'exec'; return createStdout(''); },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') { s.mode = 'config'; return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.'); }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-if-range') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(swk) { this[swk].mode = 'exec'; this[swk].currentIf = null; return createStdout(''); },

    iosInterface(swk, x) {
      const s = this[swk];
      const validModes = ['config', 'config-if', 'config-if-range'];
      if (!validModes.includes(s.mode)) return createStderr('% Invalid input detected — must be in configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[swk + 'Completion'];

      if (sub1 === 'range') {
        s.mode = 'config-if-range'; s.currentIf = 'range';
        if (!c.rangeEntered) { c.rangeEntered = true; this.updateScore(); }
        const sw12 = swk === 'sw1' || swk === 'sw2';
        return createStdout(this.guide(
          sw12
            ? `Entered range config for e0/1 and e0/2 on ${this.devLabel(swk)}. → "switchport trunk allowed vlan 56,77".`
            : `Entered range config for e0/0 and e0/1 on ${this.devLabel(swk)}. Note: in Packet Tracer these are fa0/10 and fa0/11. → "channel-group 34 mode active".`
        ));
      }

      let ifArg = String(x._[1] || '');
      let ifNorm = this.normalizeIf(ifArg);
      // SW-3/SW-4: fa0/10 → e0/0, fa0/11 → e0/1
      if (ifNorm === '0/10') ifNorm = '0/0';
      if (ifNorm === '0/11') ifNorm = '0/1';
      s.mode = 'config-if'; s.currentIf = ifNorm;

      if ((swk === 'sw1' || swk === 'sw2') && ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      if ((swk === 'sw3' || swk === 'sw4') && ifNorm === '0/2' && !c.e02If) { c.e02If = true; this.updateScore(); }
      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      const inIf = s.mode === 'config-if' || s.mode === 'config-if-range';
      if (!inIf) return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c       = this[swk + 'Completion'];
      const sub1    = (x._[1] || '').toLowerCase();
      const sub2    = (x._[2] || '').toLowerCase();
      const sub3    = (x._[3] || '').toLowerCase();
      const ifn     = s.currentIf;
      const inRange = s.mode === 'config-if-range';
      const sw12    = swk === 'sw1' || swk === 'sw2';
      const sw34    = swk === 'sw3' || swk === 'sw4';

      // switchport trunk allowed vlan 56,77
      if (sub1 === 'trunk' && sub2 === 'allowed' && sub3 === 'vlan') {
        const vlanList = x._.slice(4).join('').replace(/\s/g, '');
        const match    = vlanList === '56,77' || vlanList === '77,56';
        if (sw12 && inRange && match && !c.rangeAllowed) {
          c.rangeAllowed = true; this.updateScore();
          const other = swk === 'sw1' ? 'SW-2' : 'SW-1';
          return createStdout(this.guide(
            `${this.devLabel(swk)} e0/1 and e0/2 trunks restricted to VLANs 56 and 77. Only tagged traffic for these two VLANs will cross these links — all other VLANs are pruned. ` +
            (this.getComp(swk === 'sw1' ? 'sw2' : 'sw1').rangeAllowed
              ? '→ Configure Task 2 on SW-3 and SW-4.'
              : `→ Configure the same on ${other}.`)
          ));
        }
        if (sw34 && ifn === '0/2' && match && !c.e02Allowed) {
          c.e02Allowed = true; this.updateScore();
          const other = swk === 'sw3' ? 'SW-4' : 'SW-3';
          return createStdout(this.guide(
            `${this.devLabel(swk)} e0/2 trunk restricted to VLANs 56 and 77. Consistent allowed VLAN lists across all trunk links ensure end-to-end connectivity for both VLANs. ` +
            (this.getComp(swk === 'sw3' ? 'sw4' : 'sw3').e02Allowed
              ? '→ Configure Task 3: native VLAN on SW-1/SW-2 e0/1.'
              : `→ Configure the same on ${other}.`)
          ));
        }
        return createStdout('');
      }

      // switchport trunk native vlan 99
      if (sub1 === 'trunk' && sub2 === 'native' && sub3 === 'vlan') {
        const vlanId = String(x._[4] || '');
        if (sw12 && ifn === '0/1' && vlanId === '99' && !c.e01Native) {
          c.e01Native = true; this.updateScore();
          const other = swk === 'sw1' ? 'SW-2' : 'SW-1';
          return createStdout(this.guide(
            `Native VLAN set to 99 on ${this.devLabel(swk)} e0/1. Untagged frames on this trunk are placed into VLAN 99. Both ends of a trunk must use the same native VLAN — a mismatch causes CDP warnings and silent traffic misassignment. ` +
            (this.getComp(swk === 'sw1' ? 'sw2' : 'sw1').e01Native
              ? '→ Configure Task 4: LACP on SW-3/SW-4.'
              : `→ Configure the same on ${other}.`)
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosChannelGroup(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if' && s.mode !== 'config-if-range') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const groupNum = String(x._[1] || '');
      const modeKw   = (x._[2] || '').toLowerCase();
      const modeVal  = (x._[3] || '').toLowerCase();
      const c        = this[swk + 'Completion'];
      const sw34     = swk === 'sw3' || swk === 'sw4';
      if (sw34 && groupNum === '34' && modeKw === 'mode' && modeVal === 'active' && !c.channelGroup) {
        c.channelGroup = true; this.updateScore();
        const other = swk === 'sw3' ? 'SW-4' : 'SW-3';
        return createStdout(this.guide(
          `Port-Channel 34 created with LACP 'active' mode on ${this.devLabel(swk)}. e0/0 and e0/1 are bundled into a single logical link with combined bandwidth and automatic failover. ` +
          `'active' mode immediately initiates LACP negotiation — with both sides active the EtherChannel forms right away. ` +
          (this.getComp(swk === 'sw3' ? 'sw4' : 'sw3').channelGroup
            ? '→ Save all switches: "end" then "copy running-config startup-config".'
            : `→ Configure the same on ${other}.`)
        ));
      }
      return createStdout('');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.devLabel(swk)} configuration saved. ` + (this.saveDone ? '✓ All switches saved — simulation complete!' : '→ Save the remaining switches.'))
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal, #sw3_terminal, #sw4_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

